import { ActivityKind } from './modules/activity.types';
import { PerkTooltipKind } from './modules/perks.types';
export const activityKindLiteralMap = {
    [ActivityKind.NowViewing]: 'There are XXXXXX people looking at this hotel right now',
    [ActivityKind.TodayViewed]: 'XXXXXX people have looked at this hotel today',
    [ActivityKind.BookedToday]: 'XXXXXX people have already booked today',
    [ActivityKind.LastReservation]: 'Last reservation was XXXXXX hours ago',
    [ActivityKind.DiscountToday]: 'XXXXXX% discount only today',
    [ActivityKind.TodaySpecialOffer]: 'Today\'s special offer: XXXXXX',
};
export const perkTooltipKindLiteralMap = {
    [PerkTooltipKind.None]: 'none',
    [PerkTooltipKind.SubjectToAvailibity]: 'Subject to availability',
    [PerkTooltipKind.WebExclusive]: 'Web exclusive',
    [PerkTooltipKind.OnlyForRegisterdUsers]: 'Only for registered users',
    [PerkTooltipKind.OnlyForSpecificRates]: 'Only for specific rates',
};
//# sourceMappingURL=maps.js.map